<script setup lang="ts">
/**
 * Stands in for a file the browser can't show as a picture: everything in the
 * media library that isn't an image and didn't get a cover rasterised for it
 * (see app/utils/media-file.ts). The sheet carries what a preview would have
 * told the reader anyway — what kind of file it is, and what it is called.
 */
interface Props {
  media: Media
  /** drop the name where the sheet is too small to read one */
  compact?: boolean
}

const props = defineProps<Props>()

const label = computed(() => mediaTypeLabel(props.media))
const title = computed(() => mediaTitle(props.media))
</script>

<template>
  <div class="bg-gray text-black w-full h-full overflow-hidden flex flex-col items-center justify-center text-center p-0_5">
    <span class="text-sm">{{ label }}</span>
    <span v-if="!compact && title" class="text-xs mt-0_25 max-w-full line-clamp-2">{{ title }}</span>
  </div>
</template>
